import React from "react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { EmptyState } from "@/components/common/Page";
import { Inbox } from "lucide-react";

export const DataTable = ({ columns, rows, onRowClick, empty, testId, rowTestId }) => {
  if (!rows || rows.length === 0) {
    return (
      <EmptyState
        icon={Inbox}
        title={empty?.title || "No records yet"}
        message={empty?.message || "Records you add will appear here."}
        action={empty?.action}
        testId={`${testId}-empty`}
      />
    );
  }
  return (
    <div className="overflow-x-auto rounded-xl border border-[#1E2D4A] bg-[#111A2E]/80 backdrop-blur-sm" data-testid={testId}>
      <Table>
        <TableHeader>
          <TableRow className="border-[#1E2D4A] hover:bg-transparent">
            {columns.map((c) => (
              <TableHead key={c.key} className={`text-[11px] font-semibold uppercase tracking-wider text-slate-500 ${c.align === "right" ? "text-right" : ""}`}>
                {c.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow
              key={row.id || i}
              className={`border-[#1E2D4A] transition-colors ${onRowClick ? "cursor-pointer hover:bg-[#17233B]" : "hover:bg-[#141F35]"}`}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              data-testid={rowTestId ? `${rowTestId}-${row.id || i}` : undefined}
            >
              {columns.map((c) => (
                <TableCell key={c.key} className={`py-3 text-sm text-slate-300 ${c.align === "right" ? "text-right" : ""} ${c.mono ? "font-mono-fin" : ""}`}>
                  {c.render ? c.render(row) : row[c.key] ?? "—"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
